import React, { useEffect, useState } from "react";
import "./InputText.css";
import i18n from "i18next";

const Textarea = ({
  labelinput,
  white,
  flag = true,
  name,
  value = "",
  handleChange,
  champs,
  readOnly = false,
  placeholder,
  type = "text",
}) => {
  const [focused, setFocused] = useState("");
  const [, setmyValue] = useState(value);
  useEffect(() => {
    setmyValue(value);
    // eslint-disable-next-line
  }, [i18n.language, value]);

  return (
    <div className="text-start pt-2 pb-2 w-100">
      {labelinput && <label className="f16">{labelinput}</label>}
      <div className="d-flex align-items-center gap-2">
        {flag && (
          <div
            className={`flagInput rounded-3 flaginput${i18n.language} ${focused}`}
          ></div>
        )}
        <textarea
          readOnly={readOnly}
          rows={4}
          value={value}
          onChange={(e) => handleChange(e.target.value, champs)}
          placeholder={placeholder}
          name={name}
          className={`styleInput w-100 p-3 rounded-3 ${
            white ? "bg-white" : ""
          }`}
          onFocus={() => setFocused("flagFocused")}
          onBlur={() => setFocused("")}
        />
      </div>
    </div>
  );
};

export default Textarea;
